import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '../../../../core/Button';
import Icon from '../../../../core/Icon';
import RepositoryPicker from '../../../../core/RepositoryPicker';
import DropdownButton from '../../../../core/DropdownButton';
import absolute from '../../../../utils/pathUtil/absolute';
import { makeStyles } from '@material-ui/core/styles';
import fieldsLogic from '../logic/fieldsLogic';
import StyledText from './StyledTextInput';
import Typography from '@material-ui/core/Typography';
import helpers from '../utils/fieldsHelper';
import Utils from '../../../../utils';
import useLocalFile from '../../../../form/input/LocalFile/useLocalFile';
var useStyles = makeStyles({
  adornedEnd: {
    paddingRight: 0
  },
  inputAdornedEnd: function inputAdornedEnd(props) {
    return props.variant === 'standard' ? {} : {
      borderRight: '1px solid lightgray'
    };
  }
}, {
  name: 'ECFile'
});

var InnerInput = function InnerInput(_ref) {
  var dragAndDropFileProps = _ref.dragAndDropFileProps,
      dragAndDropInputProps = _ref.dragAndDropInputProps,
      rest = _objectWithoutProperties(_ref, ["dragAndDropFileProps", "dragAndDropInputProps"]);

  return React.createElement("div", Object.assign({
    style: {
      width: '100%'
    }
  }, dragAndDropFileProps), React.createElement("input", dragAndDropInputProps), React.createElement("input", rest));
};

var getFilePath = function getFilePath(fileData) {
  if (typeof fileData === 'string') return fileData;
  return fileData && fileData.value;
};

var getFileName = function getFileName(fileData) {
  var filePath = getFilePath(fileData);
  if (!filePath) return '';
  var embed = filePath && filePath.startsWith('data:');
  if (embed) return fileData && fileData.fileName || 'Embed File';
  return Utils.path.getFileName(filePath);
};

var isEmbeded = function isEmbeded(fileData) {
  var filePath = getFilePath(fileData);
  return filePath && filePath.startsWith('data:');
};

var isWindowsFolder = function isWindowsFolder(path) {
  var filePath = getFilePath(path);
  if (!filePath) return false;
  if (filePath.startsWith('\\\\')) return true;
  if (filePath.indexOf(':\\') > -1) return true;
  return false;
};

var decode = function decode(pathAndWorkspace, basePath) {
  if (pathAndWorkspace === null) {
    return {
      workspace: null,
      path: null
    };
  } else if (typeof pathAndWorkspace === 'string') {
    if (pathAndWorkspace.startsWith('Run')) return {
      workspace: '',
      path: pathAndWorkspace
    };
    if (pathAndWorkspace.startsWith('Design')) return {
      workspace: '',
      path: pathAndWorkspace
    };

    if (pathAndWorkspace.indexOf('/') > -1) {
      var segments = pathAndWorkspace.split('/');
      var workspace = segments.shift();
      var path = segments.join('/');
      return {
        workspace: workspace,
        path: path
      };
    }
  } else if (typeof pathAndWorkspace === 'object') {
    var _workspace = pathAndWorkspace.workspace || null;

    var _path = pathAndWorkspace.path || null;

    if (!_path) {
      return {
        workspace: _workspace,
        path: null
      };
    }

    return {
      workspace: _workspace,
      path: absolute(_path, basePath)
    };
  }

  return {
    workspace: null,
    path: null
  };
};
/**
 * @param {string} extensions
 * @returns {Array<string>} a list of extensions in the form '.ext'
 */


var parseExtensions = function parseExtensions(extensions) {
  if (!extensions) return []; // split using both ','

  var parts = extensions.split(/,|;/);
  if (parts.length === 0) return []; // remove empty entries

  parts = parts.filter(function (p) {
    return p;
  }); // remove '*' if specified

  parts = parts.map(function (p) {
    if (p.startsWith('*.')) return p.substring(2);
    if (p.startsWith('.')) return p.substring(1);
    return p;
  });
  return parts;
};

var downloadWindowsFile =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(fileUri) {
    var resourceToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Utils.apiClients.files.getLocalFileResourceToken(fileUri);

          case 3:
            resourceToken = _context.sent;
            window.open('/backend/localcontent?resourceToken=' + resourceToken + '&path=' + encodeURIComponent(fileUri), '_blank', '');
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function downloadWindowsFile(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var downloadEmbedFile = function downloadEmbedFile(fileName, fileUri) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    var _type = fileUri.split(':')[1].split(';')[0];

    var _data = atob(fileUri.split(',')[1]); // Use typed arrays to convert the binary data to a Blob


    var arraybuffer = new ArrayBuffer(_data.length);
    var view = new Uint8Array(arraybuffer);

    for (var i = 0; i < _data.length; i++) {
      view[i] = _data.charCodeAt(i) & 0xff;
    }

    try {
      var blob = new Blob([arraybuffer], {
        type: _type
      });
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } catch (e) {}

    return;
  }

  var link = document.createElement('a');
  link.download = fileName;
  link.href = fileUri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

var downloadEOSFile =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(filePath, workspace) {
    var resourceToken, host;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Utils.apiClients.files.getResourceToken(workspace, filePath);

          case 2:
            resourceToken = _context2.sent;
            host = Utils.getHost() || '/';
            window.open(host + 'backend/content?resourceToken=' + resourceToken + '&workspace=' + encodeURIComponent(workspace) + '&path=' + encodeURIComponent(filePath), '_blank', '');

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function downloadEOSFile(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var File = function File(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      repositoryOpen = _React$useState2[0],
      toggle = _React$useState2[1];

  var onUploadFile = props.onUploadFile,
      optimize = props.optimize;
  var fieldId = props.fieldId,
      dispatch = props.dispatch,
      value = props.value,
      readonly = props.readonly;
  var description = props.description,
      error = props.error,
      placeholder = props.placeholder,
      extensions = props.extensions,
      variant = props.variant;
  var disableRepositoryAccess = props.disableRepositoryAccess,
      browseLocalFiles = props.browseLocalFiles,
      browseEOSFiles = props.browseEOSFiles;
  var formWorkspace = props.workspace,
      formPath = props.formPath; // if current form is located in reserved 'system' workspace

  var isSystemForm = formWorkspace && formWorkspace.toLowerCase() === 'system';
  var classes = useStyles({
    variant: variant
  });
  var extensionsArray = parseExtensions(extensions);

  var onFocus = function onFocus() {
    return fieldsLogic.onFocus(fieldId, dispatch);
  };

  var closePicker = function closePicker() {
    return toggle(false);
  };

  var openPicker = function openPicker() {
    onFocus();
    toggle(true);
  };

  var filePath = getFilePath(value);
  var fileName = getFileName(value);

  var _ref4 = isEmbeded(filePath) ? {
    path: '',
    workspace: ''
  } : decode(filePath),
      path = _ref4.path,
      workspace = _ref4.workspace;

  var onBase64FileChanged = function onBase64FileChanged(fileName, content) {
    var mimetype = Utils.path.getFileMimeType(fileName);
    var base64url = 'data:' + mimetype + ';base64,' + content;
    fieldsLogic.onChange(fieldId, {
      fileName: fileName,
      value: base64url
    }, dispatch);
  };

  var onDelete = function onDelete() {
    fieldsLogic.onChange(fieldId, '', dispatch);
  };

  var onDownload = function onDownload() {
    if (!value) return;
    if (isWindowsFolder(value)) downloadWindowsFile(value);else if (isEmbeded(value)) downloadEmbedFile(fileName, filePath);else downloadEOSFile(path, workspace || formWorkspace);
  };

  var onChange = function onChange(value) {
    onFocus();
    if (fieldId == null) return;
    if (!value) return;

    if (onUploadFile) {
      var optimizeImageWeb = optimize && optimize !== 'none';
      var widthHeightMaxLimit = optimize && optimize !== 'none' && optimize !== 'auto' ? parseInt(optimize) : -1;
      onUploadFile(value, optimizeImageWeb, widthHeightMaxLimit).then(function (filePath) {
        return fieldsLogic.onChange(fieldId, filePath, dispatch);
      });
    } else {
      // if we have a job context, then we'll save the file in the job folder
      Utils.apiClients.content.uploadFileForBase64Content(value).then(function (content) {
        onBase64FileChanged(value.name, content);
      });
    }
  };

  var _useLocalFile = useLocalFile({
    onChange: onChange,
    accept: extensionsArray.map(function (p) {
      return '.' + p;
    }).join(',')
  }),
      getRootProps = _useLocalFile.getRootProps,
      getInputProps = _useLocalFile.getInputProps,
      open = _useLocalFile.open;

  var openLocal = function openLocal() {
    onFocus();
    open();
  };

  var descriptionContent = description ? React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: helpers.getHtmlMarkup(description)
    }
  }) : '';
  return React.createElement(React.Fragment, null, React.createElement(StyledText, {
    helperText: error || descriptionContent || React.createElement(Typography, null, " "),
    error: !!error,
    fullWidth: true,
    disabled: readonly,
    placeholder: placeholder || 'Choose a file',
    variant: variant,
    value: fileName || '',
    onClick: function onClick() {
      return onFocus();
    },
    inputProps: {
      disabled: true,
      style: {
        boxSizing: 'inherit'
      },
      dragAndDropFileProps: browseLocalFiles || disableRepositoryAccess ? _objectSpread({}, getRootProps({})) : {},
      dragAndDropInputProps: browseLocalFiles || disableRepositoryAccess ? _objectSpread({}, getInputProps()) : {
        style: {
          display: 'none'
        }
      }
    },
    InputProps: {
      classes: classes,
      inputComponent: InnerInput,
      endAdornment: React.createElement(InputAdornment, null, React.createElement(React.Fragment, null, !readonly && fileName && React.createElement(Icon, {
        hoverable: true,
        color: "error",
        buttonSize: "small",
        label: "Clear",
        tooltipPlacement: "bottom",
        type: "close",
        style: {
          marginLeft: 5
        },
        onClick: onDelete
      }), fileName && !disableRepositoryAccess && React.createElement(Icon, {
        hoverable: true,
        color: "secondary",
        buttonSize: "small",
        label: "Download",
        tooltipPlacement: "bottom",
        type: "download",
        style: {
          marginLeft: 5
        },
        onClick: onDownload
      }), !disableRepositoryAccess && browseEOSFiles && !browseLocalFiles && React.createElement(Button, {
        variant: "text",
        color: "default",
        disabled: readonly,
        onClick: openPicker
      }, "Browse"), (disableRepositoryAccess || !browseEOSFiles && browseLocalFiles) && React.createElement(Button, {
        variant: "text",
        color: "default",
        disabled: readonly,
        onClick: openLocal
      }, "Browse"), !disableRepositoryAccess && browseEOSFiles && browseLocalFiles && React.createElement(DropdownButton, {
        label: "Browse",
        buttonProps: {
          variant: 'text'
        },
        labelPlacement: "end",
        options: [{
          label: 'Repository Files',
          onClick: openPicker
        }, {
          label: 'Local Files',
          onClick: openLocal
        }]
      })))
    }
  }), browseEOSFiles && repositoryOpen && React.createElement(RepositoryPicker, {
    onChange: function onChange(selection) {
      if (selection.length) {
        var file = decode(selection[0]);

        var _filePath = "".concat(file.workspace !== formWorkspace ? file.workspace : 'Design', "/").concat(file.path);

        fieldsLogic.onChange(fieldId, _filePath, dispatch);
      } else {
        onDelete();
      }

      closePicker();
    },
    lockWorkspace: !isSystemForm // if form is in system, we allow cross workspace
    ,
    workspace: isSystemForm ? workspace : workspace || formWorkspace,
    path: path || formPath,
    onClose: closePicker,
    fileExtensions: extensionsArray
  }));
};

export default React.memo(File);